import moment from 'moment'
import React, { CSSProperties, useEffect, useMemo, useState } from 'react'
import { connect } from 'react-redux'
import { useParams } from 'react-router'
import { Button, Grid, Header, Icon, Image, Input, InputOnChangeData, Label, List, Popup } from 'semantic-ui-react'
import sort from '../../../../assets/svg/act_cluster.svg'
import filter from '../../../../assets/svg/act_filter.svg'
import filter_delete from '../../../../assets/svg/act_filter_delete.svg'
import list from '../../../../assets/svg/act_list_view.svg'
import list_active from '../../../../assets/svg/act_list_view_active.svg'
import timeline from '../../../../assets/svg/act_timeline_view.svg'
import timeline_active from '../../../../assets/svg/act_timeline_view_active.svg'
import search from '../../../../assets/svg/search_icon.svg'
import DatepickerComponent from '../../../../components/Datepicker/Datepicker'
import { ContentHeader } from '../../../../components/Header/ContentHeader'
import { useStateFromProp } from '../../../../hooks/useStateFromProps'
import { RootState } from '../../../../store/rootState'
import { IRouteParams } from '../../../../types/routeParams'
import * as CostsActions from '../../actions/directAndPassTroughCosts'
import * as ProjectActions from '../../actions/projectActions'
import { getClusteredDirectCostsSelector, getDirectCostsSelector, getFilterCountSelector } from '../../selectors/directAndPassTroughCostsSelector'
import { ICostFilter, ICostFilterOption, ICostSearch, ICostSorting, ICostsClustering, ICostsSortColumn, IDirectCost } from '../../types/directAndPassTroughCosts'
import { IProject, ViewType } from '../../types/project'


interface StateProps {
  project: IProject
  viewType: ViewType
  costFilters: ICostFilter[]
  sortCosts: ICostSorting
  filterCount: number
  searchCostsValue: ICostSearch
  costs: IDirectCost[]
  clusteredCosts: ICostsClustering[] | undefined
}

interface DispatchProps {
  setCostFilters: (costFilter: ICostFilter, queryOptions: ICostFilterOption) => void
  setViewType: (viewType: ViewType) => void
  searchCosts: (filter: ICostSearch) => void
  setSortCosts: (sorting: ICostSorting) => void
  getCostsFilters: (id: string | number) => void
  clearFilters: () => void
  exportProjectDirectCosts: (projectId: number, params: Record<string, string>) => void
}

type Props = StateProps & DispatchProps

const DirectAndPassTroughCostsHeaderContainer = (props: Props): JSX.Element => {
  const {
    project,
    viewType,
    setViewType,
    searchCosts,
    setSortCosts,
    sortCosts,
    costFilters,
    searchCostsValue,
    getCostsFilters,
    setCostFilters,
    filterCount,
    clearFilters,
    costs,
    clusteredCosts,
    exportProjectDirectCosts
  } = props

  const [open, setOpen] = useState(false)
  const [timer, setTimer] = useState<number>(0)
  const [searchLoading, setSearchLoading] = useState(false)
  const [searchQuery, setSearchQuery] = useStateFromProp(searchCostsValue.search ? searchCostsValue.search : '')

  const param: IRouteParams = useParams()

  useEffect(() => {
    getCostsFilters(param.id)
  }, [getCostsFilters, param.id])

  const filteredActs = useMemo(() => {
    return clusteredCosts?.flatMap(cluster => cluster.costs as IDirectCost[]).length
  }, [clusteredCosts])


  const filterOnClick = (costFilter: ICostFilter, queryOptions: ICostFilterOption) => {
    setCostFilters(costFilter, queryOptions)
  }

  const handleClearFilters = () => {
    clearFilters()
  }

  const handleViewTypeChange = (active: 'list' | 'timeline') => {
    if (viewType !== active) {
      setViewType(active)
    }
  }

  const onInputClick = () => {
    if (open) {
      setOpen(false)
    } else {
      setOpen(true)
    }
  }

  const changeDates = (dates: [Date, Date], costFilter: ICostFilter, queryOptions: ICostFilterOption) => {
    const [start, end] = dates
    const _queryOptions: ICostFilterOption = { ...queryOptions, 'start_date': start, 'end_date': end }
    setCostFilters(costFilter, _queryOptions)
    if (end) {
      setOpen(false)
    }
  }

  const leftItems = () => {
    return (
      <div style={{ display: 'flex', gap: '8px' }}>
        <Image
          src={viewType === 'list' ? list_active : list}
          onClick={() => handleViewTypeChange('list')}
          style={{ width: '32px', cursor: 'pointer' }}
        />
        <Image
          src={viewType === 'timeline' ? timeline_active : timeline}
          onClick={() => handleViewTypeChange('timeline')}
          style={{ width: '32px', cursor: 'pointer' }}
        />
      </div>
    )
  }

  const renderFilterDropdown = () => {
    return (
      <Grid columns='4' style={{ maxHeight: '30rem' }}>
        <Grid.Row>
          <Grid.Column as='h5' width='2'>
            Filter
          </Grid.Column>
          <Grid.Column width='10' verticalAlign='bottom'>
            <Header.Subheader style={{ fontSize: '0.85rem', colo: '#747678' }}>Active filter contains {filteredActs} of {costs.length} tasks</Header.Subheader>
          </Grid.Column>
          <Grid.Column width='4' verticalAlign='bottom'>
            <Header.Subheader onClick={handleClearFilters} style={{ cursor: 'pointer', fontSize: '0.85rem', color: '#BEC8C3' }}>Clear selection</Header.Subheader>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          {costFilters.map(filter => {
            let _listStyle: CSSProperties = { overflowX: 'hidden' }
            const _colStyle: CSSProperties = { width: '24%' }
            if (filter.name === 'Members' || filter.name === 'Departments') {
              _listStyle = { ..._listStyle, overflowY: filter.options.length > 5 ? 'scroll' : 'hidden', height: '12rem' }
              _colStyle.width = filter.name === 'Members' ? '27%' : '25%'
            }
            return (
              <Grid.Column key={filter.name} style={_colStyle}>
                <Header style={{ fontSize: '1rem' }}>{filter.name}</Header>
                <List style={_listStyle}>
                  {filter.options.map((q) => {
                    if (q.value === 'individual') {
                      return (
                        <List.Item
                          key={q.name}
                        >
                          <Label style={{ color: '#232C58', fontWeight: 400, width: '100%', background: q.selected ? '#CDF7EC' : '#F3F3F3' }} as='a'>
                            <DatepickerComponent
                              open={open}
                              onInputClick={() => onInputClick()}
                              onChange={dates => changeDates(dates as [Date, Date], filter, q)}
                              startDate={q.start_date ? moment(q.start_date).toDate() : null}
                              endDate={q.end_date ? moment(q.end_date).toDate() : null}
                              selectsRange={true}
                              dateFormat='yyyy-MM-dd'
                              customInput={<div><p>{q.name}</p></div>}
                              onClickOutside={() => setOpen(false)}
                            />
                          </Label>
                        </List.Item>
                      )
                    }
                    return (
                      <List.Item
                        key={q.name}
                        onClick={() => filterOnClick(filter, q)}
                      >
                        <Label style={{ color: '#232C58', fontWeight: 400, width: '100%', background: q.selected ? '#CDF7EC' : '#F3F3F3' }} as='a'>{q.name}</Label>
                      </List.Item>
                    )
                  })}
                </List>
              </Grid.Column>
            )
          })}
        </Grid.Row>
      </Grid>
    )
  }

  const renderSortDropdown = () => {
    return (
      <List>
        <List.Item content={'Phase'} onClick={e => handleSortSelect(e, 'phase')} style={{ cursor: 'pointer', backgroundColor: sortCosts.clustering === 'phase' ? '#CEF7EC' : '', padding: '5px 0 0 5px', width: '8.56rem', height: '1.71rem', borderRadius: '4px' }} />
        <List.Item content={'Department'} onClick={e => handleSortSelect(e, 'department')} style={{ cursor: 'pointer', backgroundColor: sortCosts.clustering === 'department' ? '#CEF7EC' : '', padding: '5px 0 0 5px', width: '8.56rem', height: '1.71rem', borderRadius: '4px' }} />
        <List.Item content={'Completion'} onClick={e => handleSortSelect(e, 'completion')} style={{ cursor: 'pointer', backgroundColor: sortCosts.clustering === 'completion' ? '#CEF7EC' : '', padding: '5px 0 0 5px', width: '8.56rem', height: '1.71rem', borderRadius: '4px' }} />
        <List.Item content={'Overall'} onClick={e => handleSortSelect(e, 'overall')} style={{ cursor: 'pointer', backgroundColor: sortCosts.clustering === 'overall' ? '#CEF7EC' : '', padding: '5px 0 0 5px', width: '8.56rem', height: '1.71rem', borderRadius: '4px' }} />
      </List>
    )
  }

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
    clearTimeout(timer)
    const _timer = window.setTimeout(() => {
      setSearchLoading(false)
    }, 300)
    searchCosts({ search: data.value })
    setTimer(_timer)
    setSearchLoading(true)
    setSearchQuery(data.value)
  }

  const handleClearSearch = () => {
    searchCosts({ search: '' })
    setSearchQuery('')
  }

  const renderSearchIcon = () => {
    if (searchQuery === '') {
      return <Image src={search} style={{ left: '-100%', top: '-2%', padding: '0.5rem' }} />
    }
    return <Icon name='close' link={true} onClick={handleClearSearch} />
  }

  const handleSortSelect = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, _sort: ICostSorting['clustering']) => {
    setSortCosts({ clustering: _sort, column: {} as ICostsSortColumn })
  }

  const handleOptionSelect = (key: string) => {
    if (key === 'export') {
      exportProjectDirectCosts(+project.id, { type: 'csv' })
    }
  }

  const renderAdditionalDropdown = () => {
    return (
      <List style={{ width: '5.2rem' }}>
        <List.Item content='Export CSV' onClick={() => handleOptionSelect('export')} style={{ cursor: 'pointer' }} />
      </List>
    )
  }

  const renderExportButton = () => {
    return (
      <Popup
        trigger={
          <Button
            size='small'
            secondary={true}
            icon={<Icon name='ellipsis horizontal' style={{ fontSize: '1.2rem' }} />}
            style={{ padding: '0', borderRadius: '8px', width: '2.3rem', height: '2.3rem', backgroundColor: '#232C58' }}
          />
        }
        style={{ marginLeft: '0.5rem' }}
        content={renderAdditionalDropdown()}
        on='click'
        position='bottom left'
      />
    )
  }

  const rightItems = () => {
    return (
      <React.Fragment>
        <Input
          loading={searchLoading}
          className='search-input-medium'
          size='small'
          style={{ width: '170px', height: '32px' }}
          icon={renderSearchIcon()}
          iconPosition='left'
          placeholder='Search'
          onChange={(e, data) => handleSearch(e, data)}
          value={searchQuery}
        />
        <div style={{ display: 'flex', gap: '8px', marginLeft: '8px' }}>
          {viewType === 'list' && <Popup
            basic
            trigger={
              <Image
                src={sort}
                style={{ width: '32px', cursor: 'pointer' }}
              />
            }
            content={renderSortDropdown()}
            on='click'
            position='bottom right'
          />}
          <Popup
            basic
            trigger={
              <Button
                primary={filterCount !== 0}
                secondary={filterCount === 0}
                content={
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', backgroundColor: '#232C58' }}>
                    <Image
                      size='mini'
                      src={filter}
                      style={{ maxWidth: '18px' }}
                    />
                    {filterCount > 0 &&
                      <Label
                        style={{
                          fontSize: '12px',
                          color: '#08D6A1',
                          background: '#FFF',
                          borderRadius: '8px',
                          height: '18px',
                          width: '29px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                        as='a'>
                        {filterCount}
                        <Image
                          src={filter_delete}
                          onClick={handleClearFilters}
                          style={{ width: '7px', height: '7px', cursor: 'pointer' }}
                        />
                      </Label>}
                  </div>
                }
                style={{ width: filterCount > 0 ? '69px' : '32px', height: '32px', borderRadius: '8px', padding: 'initial', margin: 0, backgroundColor: '#232C58' }}
              />
            }
            content={renderFilterDropdown()}
            on='click'
            position='bottom left'
            wide='very'
          />
          {viewType === 'list' && renderExportButton()}
        </div>
      </React.Fragment>
    )
  }

  return (
    <ContentHeader
      id='projectActivitiesHeader'
      title={project.name}
      color='#08D6A1'
      subtitle={project.customer?.name ?? project.category}
      leftItems={leftItems()}
      rightItemsFirst={rightItems()}
      backTitle='Activities'
      backLocation='/projects'
    />
  )
}

const mapStateToProps = (state: RootState): StateProps => {
  return {
    project: state.projectsState.project,
    viewType: state.projectsState.projectPlannerViewType,
    searchCostsValue: state.projectsState.searchCosts,
    costFilters: state.projectsState.costFilters,
    sortCosts: state.projectsState.sortCosts,
    filterCount: getFilterCountSelector(state),
    costs: getDirectCostsSelector(state),
    clusteredCosts: getClusteredDirectCostsSelector(state)
  }
}

const mapDispatchToProps = (
  dispatch: CostsActions.DirectAndPassTroughCostThunkDispatchType & ProjectActions.ProjectThunkDispatchType
): DispatchProps => {
  return {
    setCostFilters: (costFilter, queryOptions) => dispatch(CostsActions.setCostFilters(costFilter, queryOptions)),
    setViewType: viewType => dispatch(ProjectActions.setProjectViewType(viewType)),
    searchCosts: filter => dispatch(CostsActions.searchCosts(filter)),
    setSortCosts: sorting => dispatch(CostsActions.sortCosts(sorting)),
    getCostsFilters: id => dispatch(CostsActions.getCostFilters(id)),
    clearFilters: () => dispatch(CostsActions.clearCostFilters()),
    exportProjectDirectCosts: (projectId, params) => dispatch(ProjectActions.exportProjectDirectCosts(projectId, params)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DirectAndPassTroughCostsHeaderContainer)
